import { render, staticRenderFns } from "./VerValoresAdiantamentos.vue?vue&type=template&id=61509c62&"
import script from "./VerValoresAdiantamentos.vue?vue&type=script&lang=js&"
export * from "./VerValoresAdiantamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports